// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

export const REMOVE_SSO_PROVIDER = "mondoo.captain.Captain.RemoveSSOProvider";
